/**
 * Taboo Coins API Client
 *
 * API Endpoints:
 * - GET /me/coins → Wallet
 */

import type { Wallet } from '@/types';
import { apiClient } from './base-client';

export const coinsClient = {
  /**
   * Balance + recent-transactions strip (≤20 rows, newest first). Deliberately
   * not subscription-gated BE-side — users with granted coins always see them.
   */
  getWallet: async (): Promise<Wallet> => {
    const res = await apiClient.get<{ success?: boolean; data?: Partial<Wallet> }>('/me/coins');
    const data = res?.data;
    return {
      balance: typeof data?.balance === 'number' ? data.balance : 0,
      recent_transactions: Array.isArray(data?.recent_transactions) ? data.recent_transactions : [],
    };
  },
};
